
export const userTypes = {
    ADMIN: 'ADMIN',
    CLIENTS: 'CLIENTS',
    WASHER: 'WASHER',
    SETTING: 'SETTING',
    SERVICE: 'SERVICE',
    USER: "USER"
}